<template>
  <a-modal
    :visible="modalVisible"
    @cancel="modalCancel"
    @ok="modalSubmit"
    width="50%"
    cancelText="取消"
    okText="确认"
    :title="!modalType ? '创建分类' : modalType === 1 ? '编辑分类' : '分类详情'"
  >
    <a-form
      ref="formRef"
      :model="form"
      :label-col="{ span: 6 }"
      :wrapper-col="{ span: 16 }"
      :rules="rules"
    >
      <a-form-item label="名称" name="taskCategoryName">
        <a-input
          v-model:value="form.taskCategoryName"
          placeholder="请输入名称"
          style="width: 350px;"
        />
      </a-form-item>
      <!-- <a-form-item label="名称">
        <a-button
          type="dashed"
          block
          @click="addNameContent"
          style="width: 120px;"
        >
          <PlusOutlined />
        </a-button>
      </a-form-item>
      <a-form-item label="说明">
        <a-space
          v-for="(item, index) in form.taskCategoryName"
          :key="index"
          style="display: flex; margin-bottom: 8px"
          align="baseline"
        >
          <a-form-item
            :name="['taskCategoryName', index, 'key']"
            label="语言"
            :rules="{
              required: true,
              message: '请选择语言'
            }"
          >
            <a-select
              v-model:value="item.key"
              :options="langList"
              placeholder="请选择"
            >
            </a-select>
          </a-form-item>
          <a-form-item
            label="名称"
            :name="['taskCategoryName', index, 'value']"
            :rules="{
              required: true,
              message: '请输入名称'
            }"
          >
            <a-textarea
              v-model:value="item.value"
              placeholder="请输入名称"
              auto-size
            />
          </a-form-item>

          <MinusCircleOutlined @click="removeNameContent(item)" />
        </a-space>
      </a-form-item> -->
    </a-form>
  </a-modal>
</template>

<script>
import { inject, toRefs } from 'vue'
// import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons-vue'
export default {
  // components: {
  //   PlusOutlined,
  //   MinusCircleOutlined
  // },
  setup() {
    return {
      ...toRefs(inject('initState'))
    }
  }
}
</script>

<style lang="scss" scoped>
.ant-input[disabled] {
  color: #000;
}
.item {
  text-align: center;
  border: 1px solid #dedede;
  .label {
    padding: 10px 15px;
    white-space: nowrap;
  }
  .value {
    height: 100%;
    white-space: nowrap;
    padding: 10px 15px;
    border-top: 1px solid #dedede;
    .ant-form-item {
      margin: 0;
    }
  }
}
</style>
